'use strict';

module.exports = {
	selectArrows: require('./selectArrows')
};


//////////////////
// WEBPACK FOOTER
// ./~/elemental/lib/icons/index.js
// module id = 787
// module chunks = 0